<template>
  <div>
    <component :is="currentPortal"/>
  </div>
</template>

<script>
import Approvals from '@/views/components/portals/Approvals.vue';
import NominationsCreate from '@/views/components/portals/awards/NominationsCreatePortal.vue';
import NominationsEdit from '@/views/components/portals/awards/NominationsEditPortal.vue';
import ReferencesEdit from '@/views/components/portals/awards/ReferencesEditPortal.vue';
import ReviewsEdit from '@/views/components/portals/awards/ReviewsEditPortal.vue';
import ReportsEdit from '@/views/components/portals/awards/ReportsEditPortal.vue';
/* eslint-disable vue/no-unused-components */
import {
  IfacCollapsibleSidePanel,
} from '@ifac/ui';

export default {
  name: 'PortalContent',
  components: {
    Approvals,
    IfacCollapsibleSidePanel,
  },
  data() {
    return {
      portals: {
        ApprovalsEdit: Approvals,
        NominationsCreate,
        NominationsEdit,
        ReferencesEdit,
        ReviewsEdit,
        ReportsEdit,
      },
    };
  },
  computed: {
    currentPortal() {
      return this.portals[this.$route.name];
    },
    displayNav() {
      return ['PostRegister', 'ConferencesApply']
        .includes(this.$route.name);
    },
    headerText() {
      return this.sidePanelView === 0 ? 'Application' : 'Comments and recommendations';
    },
    iconList() {
      const iconList = [{ icon: ['far', 'tasks'] }];

      if (!this.speechBubbleDisabled) {
        iconList.push({ icon: ['far', 'comment'] });
      }

      return iconList;
    },
    conferenceId() {
      return this.$route?.params?.conferenceId || '';
    },
    sidePanelComponents() {
      return [
        {
          component: 'IfacConferenceData',
          options: {
            data: this.conference,
            isLoading: this.conferenceLoading,
          },
        },
        {
          component: 'IfacApprovalComments',
          options: {
            data: this.approvalsTrees,
            isLoading: this.approvalsTreesLoading,
            expandSectionsByDefault: true,
            expandHierarchyTreeByDefault: true,
            expandNestedHierarchyByDefault: true,
          },
        },
      ];
    },
    activeComponent() {
      return this.sidePanelComponents[this.sidePanelView];
    },
  },
};
</script>
